<nav>
  <h3>D3 Charts</h3>

  <app-nav-bar></app-nav-bar>
</nav>

<router-outlet></router-outlet>
